import { render, staticRenderFns } from "./AuctionListItem.vue?vue&type=template&id=0b8f6d58&scoped=true&"
import script from "./AuctionListItem.vue?vue&type=script&lang=js&"
export * from "./AuctionListItem.vue?vue&type=script&lang=js&"
import style0 from "./AuctionListItem.vue?vue&type=style&index=0&id=0b8f6d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8f6d58",
  null
  
)

export default component.exports